import React, { Fragment } from "react";
import UseTerms from "../components/UseTerms";

const Terms = () => {
  return (
    <Fragment>
      <h1>약관</h1>
      <hr />
      <UseTerms />
    </Fragment>
  );
};

export default Terms;
